





















































































import {Component, Prop} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {EditTenantInfo} from "@/api/center"

@Component
export default class AddOrEdit extends AbpBase{
    @Prop({required: true, default: false}) value:boolean
    @Prop() data:any
    model:any = {}
    get title() {
        return this.data.mode === 'add' ? '新增' : '编辑'
    }
    created() {
        if (this.data.mode === 'add') {

        } else {
            this.model = Object.assign({}, this.data.data)
        }
    }
    async save() {
        let res = await EditTenantInfo(this.model)
        if (res.code === 2000) {
            this.$emit('save-success')
        }
    }
    cancel() {
        this.$emit('input', false)
    }
    modelRule = {
        
    }
}
